<template>
  <div class="container">
    <div class="course-box">
      <div class="course-title">货主 ID 获取操作步骤说明：</div>
      <div class="steps">
        <div class="step" v-for="(item, index) in list" :key="index">
          <div class="step-text">{{ item.text }}</div>
          <div class="step-small" v-if="item.text1">{{ item.text1 }}</div>
          <img v-if="item.img" :class="item.imgClass" :src="item.img" @click="openImg(item.img)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from "vant";
export default {
  name: "index",
  data() {
    return {
      list: [
        {
          text: '1.浏览器登录聚水潭系统首页',
        },
        {
          text: '2.【鼠标右键-检查】或按F12，进入查看页面',
          img: require('../../assets/JST/course1.png'),
          imgClass: 'small',
        },
        {
          text: '2.【鼠标右键-检查】或按F12，进入查看页面。选择“网络”页签，并清空历史数据。',
          img: require('../../assets/JST/course2.png'),
        },
        {
          text: '3.点击聚水潭系统菜单【仓储-我的货主】',
          img: require('../../assets/JST/course3.png'),
        },
        {
          text: '3.点击聚水潭系统菜单【仓储-我的货主】，在检查页面，找到请求名称“GetWmsAllOwnerWarningData?”-->data下方会有多个coId，按聚水潭系统页面货主名称排序，匹配查找请求下data对应顺序的coId（货主ID）',
          text1: '如下图中货主“黄金版三方仓测试”的货主ID为15067895',
          img: require('../../assets/JST/course4.png'),
        },
      ],
    };
  },
  computed: {
    imgList() {
      return this.list.map(item => item.img || '').filter(img => img);
    },
  },
  methods: {
    openImg(img) {
      ImagePreview({
        images: this.imgList,
        startPosition: this.imgList.indexOf(img),
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  padding: 24px 20px;
  width: 100%;
  color: #333333;
  font-weight: 500;
  font-family: PingFang SC, PingFang SC;
  background: #F5F5F5;

  .course-box {
    padding: 24px 32px;
    border-radius: 16px;
    background: #FFFFFF;
  }

  .course-title {
    padding-bottom: 26px;
    font-size: 32px;
    border-bottom: 1px solid #E2E4EA;
  }

  .step {
    margin-top: 24px;
    line-height: 40px;
    font-size: 28px;
    word-break: break-all;
  }

  .step-small {
    margin-top: 8px;
    font-size: 26px;
    font-weight: 400;
  }

  img {
    margin-top: 16px;
    width: 100%;
    margin-top: 20px;
    border-radius: 16px;

    &.small {
      width: 364px;
    }
  }
}
</style>
